import React from 'react';
import { TagCloud } from '@cp/ds/src/components/tagCloud';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { coreCareerApi } from '@cp/entities/career';
import { useSubcatalogSpecializationLinks } from 'src/entities/catalog';
import { CatalogSpecializationTagCloudProps } from './types';

export const CatalogSpecializationTagCloud: React.FC<CatalogSpecializationTagCloudProps> = (props) => {
  const { careerId, itemType, ...tagCloudProps } = props;
  const { data: careerDictionary, isLoading: isLoadingCareerDictionary } = coreCareerApi.endpoints.getCareers.useQuery();
  const { links, isLoading: isLoadingLinks } = useSubcatalogSpecializationLinks(props);

  const isLoading = isLoadingCareerDictionary || isLoadingLinks;

  const careerName =
    careerDictionary?.[careerId].translation[itemType === CatalogItemType.Resume ? 'nameSingleAccusative' : 'nameSingleInstrumental'];

  const title = careerName
    ? itemType === CatalogItemType.Resume
      ? `Найти ${careerName.toLocaleLowerCase()}`
      : `Работа ${careerName.toLocaleLowerCase()}`
    : '';

  return isLoading ? <ContentSkeleton blocks={3} /> : <TagCloud items={links} title={title} {...tagCloudProps} />;
};
